import { Row, RenderConfig, TextInput, NumberInput } from 'commons-ui';
import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, RESOURCES } from '../../../constant';

export const FORM_FIELD_KEYS = {
	EMAIL: 'email',
	ZUPEE_USER_ID: 'uid',
	PHONE_NUMBER: 'phone'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.EMAIL]: 'Email',
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: 'Zupee User Id',
	[FORM_FIELD_KEYS.PHONE_NUMBER]: 'Phone Number'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.EMAIL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.EMAIL])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ZUPEE_USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ZUPEE_USER_ID])
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.PHONE_NUMBER]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.PHONE_NUMBER)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.PHONE_NUMBER])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		})
};

export const FORM_LAYOUT_CONFIG = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const hasViewEmailPermission = hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: RESOURCES.basicDetails,
		configActionName: ACTION.viewEmail
	});

	const hasViewPhonePermission = hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: RESOURCES.basicDetails,
		configActionName: ACTION.viewPhone
	});

	const rows = [new Row(FORM_FIELD_KEYS.ZUPEE_USER_ID)];

	if (hasViewPhonePermission) {
		rows.push(new Row(FORM_FIELD_KEYS.PHONE_NUMBER));
	}

	if (hasViewEmailPermission) {
		rows.push(new Row(FORM_FIELD_KEYS.EMAIL));
	}

	return rows;
};
